import { useCounterStore } from "@/store/user";
import { computed } from "vue";
import { useRoute } from "vue-router";
export const useRouterGroup = () => {
    const route = useRoute();
    const useStore = useCounterStore();
    const userInfo = useStore.getUserInfo;
    const workbenchModels = userInfo.type === "master" ? ["container-overview"] : [];
    const resourceModels = userInfo.type === "master"
        ? [
            "cluster",
            "node",
            "virtualMachine",
            "memory",
            "ssh",
            "extend",
            "queue"
        ]
        : ["cluster", "node", "virtualMachine", "memory", "ssh"];
    const accountModels = computed(() => {
        if (userInfo.type === "master") {
            if ([1, 2].includes(userInfo.alliance_type)) {
                return ["personal", "money", "access", "teamManage"];
            }
            return ["personal", "money", "access", "teamGuide"];
        }
        return ["personal"];
    });
    const application = ["model", "data-module"];
    const mirrorList = ["prefab-mirror", "mirror"];
    const routeList = computed(() => ({
        workbench: {
            label: "",
            value: [],
            includeModel: [workbenchModels]
        },
        resource: {
            label: "容器服务",
            value: [],
            includeModel: [resourceModels]
        },
        mirrorList: {
            label: "镜像服务",
            value: [],
            includeModel: [mirrorList]
        },
        application: {
            label: "AI与机器学习",
            value: [],
            includeModel: [application]
        },
        account: {
            label: "账户管理",
            value: [],
            includeModel: [accountModels.value] // 正确依赖
        },
        help: {
            label: "帮助中心",
            value: [],
            includeModel: [["concat", "question"]]
        }
    }));
    const findKeyByIncludeModel = (data, target) => {
        for (const key in data) {
            if (data[key].includeModel.some((arr) => arr.includes(target))) {
                return key;
            }
        }
        return "";
    };
    const activeRouterName = computed(() => {
        const value = route.matched[0].name === "log"
            ? userInfo.type === "admin"
                ? "manager"
                : "GPU"
            : findKeyByIncludeModel(routeList.value, route.matched[0].name);
        return value;
    });
    return { routeList, activeRouterName };
};
